import { COMPUTER_COMMAND_MENU_TRIGGER } from '#pplx/frontend/apps/ask/ask-input/ask-input-types/index.js';
import { $replaceActiveComputerCommandQuery } from '#pplx/frontend/components/form/lexical/plugins/ComputerCommandQueryPluginSupport.js';
import { $createMentionNode, $isMentionNode, } from '#pplx/frontend/composer-sdk/lexical/nodes/MentionNodeSupport.js';
import { $isSlashHintNode } from '#pplx/frontend/composer-sdk/lexical/nodes/SlashHintNodeSupport.js';
import { $createParagraphNode, $createTextNode, $getRoot, $getSelection, $isElementNode, $isRangeSelection, $isTextNode, $setSelection, } from 'lexical';
export function insertMentionNode(editor, props, options = {}) {
    editor.update(() => {
        if (hasMentionNode($getRoot(), props)) {
            return;
        }
        const mentionNode = $createMentionNode(props);
        const spaceNode = $createTextNode(' ');
        const selection = $getSelection();
        if (options.replaceActiveCommandQuery &&
            $replaceActiveComputerCommandQuery([mentionNode, spaceNode])) {
            finalizeInsertedMention(spaceNode, options);
            return;
        }
        if (options.replaceActiveCommandQuery &&
            replaceActiveCommandQuery(selection, mentionNode, spaceNode, options)) {
            return;
        }
        if (isCollapsedSelectionAtTextNodeEnd(selection)) {
            selection.insertNodes([mentionNode, spaceNode]);
            finalizeInsertedMention(spaceNode, options);
            return;
        }
        appendToRoot(mentionNode, spaceNode);
        finalizeInsertedMention(spaceNode, options);
    }, { discrete: true });
}
export function removeMentionNode(editor, props) {
    editor.update(() => {
        removeMentionNodeFromTree($getRoot(), props);
        $setSelection(null);
    }, { discrete: true });
}
function finalizeInsertedMention(spaceNode, options) {
    if (options.selectAfterInsert === false) {
        $setSelection(null);
        return;
    }
    spaceNode.selectEnd();
}
function replaceActiveCommandQuery(selection, mentionNode, spaceNode, options) {
    if (!$isRangeSelection(selection) || !selection.isCollapsed()) {
        return false;
    }
    const anchorNode = selection.anchor.getNode();
    if (!$isTextNode(anchorNode)) {
        return false;
    }
    const text = anchorNode.getTextContent();
    const textBeforeCursor = text.slice(0, selection.anchor.offset);
    const triggerMatch = Array.from(textBeforeCursor.matchAll(/(^|\s)\//g)).pop();
    const triggerIndex = triggerMatch?.index;
    if (triggerIndex === undefined) {
        return false;
    }
    const removalStart = text[triggerIndex] === COMPUTER_COMMAND_MENU_TRIGGER
        ? triggerIndex
        : triggerIndex + COMPUTER_COMMAND_MENU_TRIGGER.length;
    anchorNode.setTextContent(text.slice(0, removalStart) + text.slice(selection.anchor.offset));
    const nextSibling = anchorNode.getNextSibling();
    if ($isSlashHintNode(nextSibling)) {
        nextSibling.remove();
    }
    anchorNode.select(removalStart, removalStart).insertNodes([mentionNode, spaceNode]);
    finalizeInsertedMention(spaceNode, options);
    return true;
}
function hasMentionNode(node, props) {
    if ($isMentionNode(node)) {
        return (node.__props.variant === props.variant &&
            (node.__props.uuid === props.uuid ||
                (props.variant === 'skills' && node.__props.text === props.text)));
    }
    return $isElementNode(node) && node.getChildren().some((child) => hasMentionNode(child, props));
}
function removeMentionNodeFromTree(node, props) {
    if ($isMentionNode(node)) {
        if (node.__props.variant === props.variant && node.__props.uuid === props.uuid) {
            removeFollowingInsertedSpace(node);
            node.remove();
        }
        return;
    }
    if ($isElementNode(node)) {
        node.getChildren().forEach((child) => removeMentionNodeFromTree(child, props));
    }
}
function removeFollowingInsertedSpace(node) {
    const nextSibling = node.getNextSibling();
    if (!$isTextNode(nextSibling)) {
        return;
    }
    const text = nextSibling.getTextContent();
    if (text === ' ') {
        nextSibling.remove();
        return;
    }
    if (text.startsWith(' ') && !hasPreviousTextSibling(node)) {
        nextSibling.setTextContent(text.slice(1));
    }
}
function hasPreviousTextSibling(node) {
    const previousSibling = node.getPreviousSibling();
    return $isTextNode(previousSibling) && previousSibling.getTextContent().trim() !== '';
}
function isCollapsedSelectionAtTextNodeEnd(selection) {
    if (!$isRangeSelection(selection) || !selection.isCollapsed()) {
        return false;
    }
    const anchorNode = selection.anchor.getNode();
    return $isTextNode(anchorNode) && selection.anchor.offset === anchorNode.getTextContentSize();
}
function appendToRoot(...nodes) {
    const root = $getRoot();
    const lastChild = root.getLastChild();
    if ($isElementNode(lastChild)) {
        lastChild.append(...nodes);
        return;
    }
    root.append($createParagraphNode().append(...nodes));
}
//# sourceMappingURL=insertMentionNode.js.map